import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { AllegroOrdersResponse } from "../../types/AllegroOrdersTypes";

export default function useGetOrders(page: number) {
  return useQuery({
    queryKey: ["orders", page],
    queryFn: async () => {
      return axiosInstance.get(`/orders?page=${page}`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: AllegroOrdersResponse) => data,
    retry: false,
  });
}
